import type { NotificationAction } from "@/api";

export const notificationBadge = (count: number): string => count > 99 ? "99+" : String(Math.max(0, count));

export const findOwnedNotificationEntity = <T extends { id: string }>(entities: readonly T[], requestedId: string | null): T | null =>
	requestedId ? (entities.find((entity) => entity.id === requestedId) ?? null) : null;

export const resolveBuyerNotificationAction = (action?: NotificationAction): string | null => {
	if (!action) return null;
	switch (action.kind) {
		case "order":
			return `/profile/orders/${encodeURIComponent(action.orderId)}`;
		case "product":
			return `/product/${encodeURIComponent(action.productId)}`;
		case "shop":
			return `/shop/${encodeURIComponent(action.shopSlug)}`;
		case "chat":
			return `/chats?conversation=${encodeURIComponent(action.conversationId)}`;
		case "profile":
			return "/profile";
	}
	return null;
};
